import { Component, Injector, Input, Optional } from '@angular/core';
import { ClienteUnicoDto, ClienteUnicoServiceProxy, OrderDto, OrdersServiceProxy } from '../../services/service-proxy/service-proxies';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, tap } from 'rxjs';
import { AppService, OrderStatus } from '../../services/app.service';


@Component({
  selector: 'app-order-list-item',
  templateUrl: './order-list-item.component.html',
  styleUrls: ['./order-list-item.component.scss']
})
export class OrdersListItemComponent {


  @Input() order!: OrderDto;
  orderStatus! : OrderStatus;


  constructor(public appService : AppService, 
              private router: Router) {
            
  }

  ngOnInit() {
    this.orderStatus = this.appService.convertirLogisticStatus(this.order);
  }

  goToOrderDetail(order : OrderDto){

    this.appService.saveOrder(order);
    this.router.navigateByUrl('/order');
  }

  getImageDefault(){
    return '../assets/images/image-product-no-available.png';
  }

  loadErrorImage(event : Event){
    (event.target as HTMLImageElement).src = this.getImageDefault();
  }
}